export default __webpack_public_path__ + "static/media/20 Track 20.ef7948b3.mp3";